export default "__VITE_ASSET__DGIdzOZX__"